export enum FileTypeEnum {
  CSV,
  EXCEL,
}
